<template>
  <div class="page-shop-manage-add">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">澳門門店</div>
      <div class="breadcrumb-item">新增店櫃</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <div class="pg-form-wrap">
        <Row>
          <Col span="11">
            <Form :label-width="300">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃序碼</span>
                </div>
                <Input v-model="form.cainiao_match"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃名稱</span>
                </div>
                <Input v-model="form.ReceivingName"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃名稱（簡稱）</span>
                </div>
                <Input v-model="form.ReceivingNameShort"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃區域</span>
                </div>
                <Select placeholder="請選擇" v-model="form.macauDistrict">
                  <Option value="澳门半岛花地玛堂区">澳门半岛花地玛堂区</Option>
                  <Option value="澳门半岛花王堂区">澳门半岛花王堂区</Option>
                  <Option value="澳门半岛望德堂区">澳门半岛望德堂区</Option>
                  <Option value="澳门半岛大堂区">澳门半岛大堂区</Option>
                  <Option value="澳门半岛风顺堂区">澳门半岛风顺堂区</Option>
                  <Option value="离岛嘉模堂区">离岛嘉模堂区</Option>
                  <Option value="离岛路氹填海区">离岛路氹填海区</Option>
                  <Option value="离岛圣方济各堂区">离岛圣方济各堂区</Option>
                  <Option value="其他區">其他区</Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃地址</span>
                </div>
                <Input v-model="form.ReceivingAddress"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>經度</span>
                </div>
                <Input
                  v-model="form.X"
                  placeholder="沒有找到可以先輸入0"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>緯度</span>
                </div>
                <Input
                  v-model="form.Y"
                  placeholder="沒有找到可以先輸入0"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>自提點類型</span>
                </div>
                <Select placeholder="請選擇" v-model="form.Type">
                  <Option :value="1">門店</Option>
                  <Option :value="2">智能櫃</Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>營業開始時間</span>
                </div>
                <TimePicker
                  class="no-suffix"
                  type="time"
                  :clearable="false"
                  placeholder="營業開始日期"
                  v-model="form.start_time"
                  value-format="hh:mm:ss"
                  style="width: 100%"
                  :disabled="form.do_type === 2"
                ></TimePicker>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>店櫃關聯公司</span>
                </div>
                <Select
                  v-model="form.company_id"
                  placeholder="請選擇店櫃關聯公司"
                >
                  <Option
                    :value="item.id"
                    v-for="(item, index) in samecityList"
                    :key="item.id"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem v-if="this.$store.state.logInfo.type == 1">
                <div slot="label" class="form-label">
                  <!-- <em class="red">* </em> -->
                  <span>門店人員-關聯帳號</span>
                </div>
                <Select v-model="form.admin_id" placeholder="請選擇">
                  <Option
                    :value="item.user_id"
                    v-for="(item, index) in pickAdmin"
                    :key="item.user_id"
                    >{{ item.username }} ({{ item.realname }})
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否北上取件</span>
                </div>
                <Checkbox
                  v-model="form.north_pick_up"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>線下(門店/智能櫃)簽收立減3元(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.offline_activity"
                  :true-value="3"
                  :false-value="0"
                ></Checkbox>
                <!-- <Input v-model="form.do_type"></Input> -->
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>線下(門店/智能櫃)簽收立減3元(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.offline_activity"
                  :true-value="3"
                  :false-value="0"
                ></Checkbox>
                <!-- <Input v-model="form.do_type"></Input> -->
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <!-- <em class="red">* </em> -->
                  <span>線上APP支付快遞立減3元(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.activity"
                  :true-value="3"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>地址顯示在APP(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.style_open"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否為加盟店(直營店不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.join"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否加入好物對換(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_shop"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否發送快件超時短訊通知？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_outtime_sms"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>
            </Form>
          </Col>

          <Col span="11" push="1">
            <Form :label-width="300">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>儲存數量</span>
                </div>
                <Input v-model="form.SaveQuantity"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>大格數量</span>
                </div>
                <Input v-model="form.large"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>中格數量</span>
                </div>
                <Input v-model="form.medium"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>小格數量</span>
                </div>
                <Input v-model="form.fine"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>智能櫃代號</span>
                </div>
                <Input
                  v-model="form.location_id"
                  placeholder="沒有請輸入 0"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>聯絡電話(珠海倉庫)</span>
                </div>
                {{ form.tel }}
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>營業結束時間</span>
                </div>
                <TimePicker
                  class="no-suffix"
                  type="time"
                  :clearable="false"
                  placeholder="結束日期"
                  v-model="form.end_time"
                  value-format="hh:mm:ss"
                  style="width: 100%"
                  :disabled="form.do_type === 2"
                ></TimePicker>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <!-- <em class="red">* </em> -->
                  <span>關聯專線</span>
                </div>
                <Select v-model="form.is_delivery" placeholder="請選擇關聯專線">
                  <Option :value="0">沒有</Option>
                  <Option
                    :value="item.id"
                    v-for="(item, index) in deliveryareaList"
                    :key="item.id"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>APP時間設置</span>
                </div>
                <Input v-model="form.time_description"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <!-- <em class="red">* </em> -->
                  <span>是否24小時營業(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.do_type"
                  :true-value="2"
                  :false-value="1"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否設定送貨上門(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.delivery"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否設定送貨上門支付方式(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.delivery_default"
                  :true-value="1"
                  :false-value="null"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否參加抽獎？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_lottery"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span
                    >是否打折（範圍1-100百分比，0表示不打折,80表示打8折）</span
                  >
                </div>
                <InputNumber :max="100" :min="0" v-model="form.discount_bili" />
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否發送上架短訊？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_sms"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否拼多多包郵門店？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_pdd"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>是否淘寶包郵門店？(沒有不用勾選)</span>
                </div>
                <Checkbox
                  v-model="form.is_taobao"
                  :true-value="1"
                  :false-value="0"
                ></Checkbox>
              </FormItem>
            </Form>
          </Col>
        </Row>

        <div class="pg-btn-wrap" style="text-align: center">
          <div class="pg-btn style1" @click="handleCheckForm">確定</div>
          <div class="pg-btn" @click="handleBack">返回</div>

          <!--<Button type="error" :loading="true" class="loading-btn">
							<span>Loading...</span>
					</Button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        cainiao_match: "", //菜鳥碼
        ReceivingName: "", //網點名稱
        ReceivingNameShort: "", //網點名稱簡稱
        macauDistrict: "", //網點區域
        ReceivingAddress: "", //網點地址
        Type: 1, //自提點類型 1门店, 2智能柜
        X: 0, //经度
        Y: 0, //纬度
        SaveQuantity: 3000, //存储数量
        large: 1000, //大格數量
        medium: 1000, //中格数量
        fine: 1000, //小格数量
        location_id: "", //柜代号
        tel: 17368262086,
        admin_id: 0,
        activity: 0,
        offline_activity: 0,
        join: 0,
        style_open: 0,
        start_time: "11:00:00",
        end_time: "20:00:00",
        time_description: "",
        delivery: 0,
        delivery_default: null,
        is_lottery: 0,
        do_type: 1,
        company_id: "",
        is_delivery: 0,
        is_shop: 0,
        is_sms: 0,
        is_pdd: 0,
        is_taobao: 0,
        is_outtime_sms: 0,
        north_pick_up: 0,
        discount_bili: 0,
      },
      isSubmiting: false,
      pickAdmin: [],
      samecityList: [],
      deliveryareaList: [],
    };
  },
  mounted() {
    this.getPickAdmin();
    this.getSamcityList();
    this.getDeliveryareaList();
    if (this.$store.state.logInfo.type == 2) {
      this.form.admin_id = this.$store.state.logInfo.user_id;
    }
  },
  methods: {
    getDeliveryareaList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliveryareaList,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.deliveryareaList = res.data.data;
          }
        });
    },
    getSamcityList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.samecityUserList,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.samecityList = res.data.data;
          }
        });
    },
    getPickAdmin() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAdmin,
          method: "post",
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAdmin = res.data.data;
          }
        });
    },
    handleBack() {
      this.$router.go(-1);
    },
    handleCheckForm() {
      let form = this.form;
      if (form.cainiao_match === "") {
        this.$Utils.showTipInfo("請輸入店櫃序碼");
        return;
      } else if (form.ReceivingName === "") {
        this.$Utils.showTipInfo("請輸入店櫃名稱");
        return;
      } else if (form.ReceivingNameShort === "") {
        this.$Utils.showTipInfo("請輸入店櫃名稱（簡稱）");
        return;
      } else if (form.macauDistrict === "") {
        this.$Utils.showTipInfo("請選擇店櫃區域");
        return;
      } else if (form.ReceivingAddress === "") {
        this.$Utils.showTipInfo("請輸入店櫃地址");
        return;
      } else if (form.X === "") {
        this.$Utils.showTipInfo("請輸入經度");
        return;
      } else if (form.Y === "") {
        this.$Utils.showTipInfo("請輸入緯度");
        return;
      } else if (form.Type === "") {
        this.$Utils.showTipInfo("請選擇自提點類型");
        return;
      } else if (form.SaveQuantity === "") {
        this.$Utils.showTipInfo("請輸入儲存數量");
        return;
      } else if (form.large === "") {
        this.$Utils.showTipInfo("請輸入大格數量");
        return;
      } else if (form.medium === "") {
        this.$Utils.showTipInfo("請輸入中格數量");
        return;
      } else if (form.fine === "") {
        this.$Utils.showTipInfo("請輸入小格數量");
        return;
      } else if (form.location_id === "") {
        this.$Utils.showTipInfo("請輸入智能櫃代號");
        return;
      } else if (form.tel === "") {
        this.$Utils.showTipInfo("請輸入聯絡電話");
        return;
      } else if (form.start_time === "") {
        this.$Utils.showTipInfo("請輸入營業開始時間");
        return;
      } else if (form.end_time === "") {
        this.$Utils.showTipInfo("請輸入營業結束時間");
        return;
      } else if (form.time_description === "") {
        this.$Utils.showTipInfo("請輸入APP時間設置");
        return;
      } else if (form.company_id === "") {
        this.$Utils.showTipInfo("請輸入同城主號關聯");
        return;
      }
      if (form.is_lottery === 1 && form.activity === 3) {
        this.$Utils.showTipInfo("注意:參與抽獎不能和線上APP立減一齊選擇!");
        return;
      }
      this.handleSubmit();
    },
    handleSubmit() {
      let form = this.form;
      this.isSubmiting = true;

      this.$Rq
        .requestAuth({
          url: this.$Api.shopAdd,
          method: "post",
          data: {
            cainiao_match: form.cainiao_match, //菜鳥碼
            ReceivingName: form.ReceivingName, //網點名稱
            ReceivingNameShort: form.ReceivingNameShort, //網點名稱簡稱
            macauDistrict: form.macauDistrict, //網點區域
            ReceivingAddress: form.ReceivingAddress, //網點地址
            Type: form.Type, //自提點類型 1门店, 2智能柜
            X: form.X, //经度
            Y: form.Y, //纬度
            SaveQuantity: Number(form.SaveQuantity), //存储数量
            large: Number(form.large), //大格數量
            medium: Number(form.medium), //中格数量
            fine: Number(form.fine), //小格数量
            location_id: Number(form.location_id), //柜代号
            tel: form.tel,
            admin_id: form.admin_id,
            activity: Number(form.activity),
            offline_activity: Number(form.offline_activity),
            join: Number(form.join),
            start_time: form.start_time,
            end_time: form.end_time,
            style_open: Number(form.style_open),
            time_description: form.time_description,
            delivery: Number(form.delivery),
            delivery_default: form.delivery_default,
            is_lottery: Number(form.is_lottery),
            do_type: Number(form.do_type),
            company_id: Number(form.company_id),
            is_delivery: Number(form.is_delivery),
            is_shop: Number(form.is_shop),
            is_sms: Number(form.is_sms),
            is_pdd: Number(form.is_pdd),
            is_taobao: Number(form.is_taobao),
            is_outtime_sms: Number(form.is_outtime_sms),
            north_pick_up: form.north_pick_up,
            discount_bili: form.discount_bili,
          },
        })
        .then((res) => {
          this.isSubmiting = false;

          if (res.code == 0) {
            this.$Utils.showSuccess(res.msg);
            this.form = {
              cainiao_match: "",
              ReceivingName: "",
              ReceivingNameShort: "",
              macauDistrict: "",
              ReceivingAddress: "",
              Type: 1,
              X: 0,
              Y: 0,
              SaveQuantity: 3000,
              large: 1000,
              medium: 1000,
              fine: 1000,
              location_id: "",
              activity: 0,
              offline_activity: 0,
              tel: 17368262086,
              start_time: "11:00:00",
              end_time: "20:00:00",
              join: 0,
              style_open: 0,
              time_description: "",
              delivery: 0,
              delivery_default: null,
              is_lottery: 0,
              do_type: 1,
              company_id: "",
              is_delivery: 0,
              is_shop: 0,
              is_sms: 0,
              is_pdd: 0,
              is_taobao: 0,
              is_outtime_sms: 0,
              north_pick_up: 0,
              discount_bili: 0,
            };
          } else {
            this.$Utils.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "ShopManageAdd";
</style>
